import {AurDataGridColDef} from '../types/types';
import {t} from 'i18next';
import {getUTCDateTimeForDisplay, numberFormatter} from './utils';

export const getHighLevelProductionMetricTableColumns =
  (): AurDataGridColDef[] => [
    {
      field: 'productionName',
      headerName: t('productionMetrics.productionName'),
      minWidth: 154,
      sortable: false,
      flex: 1,
    },
    {
      field: 'dateTime',
      headerName: t('productionMetrics.dateTime'),
      minWidth: 154,
      sortable: true,
      flex: 1,
      ascFieldName: 'Chronological',
      descFieldName: 'Reverse Chronological',
      isDateColumn: true,
      renderCell: (params) => (
        <span>{getUTCDateTimeForDisplay(params.value)}</span>
      ),
    },
    {
      field: 'size',
      headerName: t('productionMetrics.sizeGB'),
      minWidth: 130,
      sortable: true,
      flex: 1,
      renderCell: (params) => {
        const row = params.row;
        return (
          <span>
            {row?.size !== undefined && row?.size !== null
              ? numberFormatter(row?.size?.toFixed(3))
              : ''}
          </span>
        );
      },
    },
    {
      field: 'docCount',
      headerName: t('productionMetrics.docCount'),
      minWidth: 154,
      sortable: true,
      flex: 1,
      valueGetter: (value) => numberFormatter(value),
    },
    {
      field: 'firstBates',
      headerName: t('productionMetrics.firstBates'),
      sortable: true,
      minWidth: 154,
      flex: 1,
      ascFieldName: 'A->Z',
      descFieldName: 'Z->A',
    },
    {
      field: 'lastBates',
      headerName: t('productionMetrics.lastBates'),
      sortable: true,
      minWidth: 154,
      flex: 1,
      ascFieldName: 'A->Z',
      descFieldName: 'Z->A',
    },
    {
      field: 'imageCount',
      headerName: t('productionMetrics.imageCount'),
      sortable: true,
      minWidth: 154,
      flex: 1,
      valueGetter: (value) => numberFormatter(value),
    },

    {
      field: 'nativeCount',
      headerName: t('productionMetrics.nativeCount'),
      sortable: true,
      minWidth: 154,
      flex: 1,
      isBorderNotRequired: true,
      valueGetter: (value) => numberFormatter(value),
    },
  ];
